<template>
  <v-sheet class="scrollable h20">
    <Loader v-if="loading" />
    <!-- <v-img contain :src="source" :width="width" max-width="100%" @load="loading = false"> </v-img> -->
    <v-img
      class="img"
      :width="width"
      :src="source"
      @load="loading = false"
      @error="loading = false"
    />
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";
import Loader from "./Loader.vue";

export default Vue.extend({
  components: { Loader },
  name: "ImageSlot",

  data() {
    return {
      loading: true,
    };
  },
  props: {
    source: VueTypes.string.def(""),
    width: VueTypes.string.def("100%"),
  },
});
</script>
<style>
.img {
  max-width: 100% !important;
}
</style>
